module.exports = __webpack_public_path__ + "static/img/home-banners3.6cd8b02a.jpg";